import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { UserRolePermissionListResponse } from '@magnetar/admin-api-interfaces'

export function useUserRolePermissionByRoleId(roleId: number, enabled: boolean = true) {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<UserRolePermissionListResponse>(
    token && enabled ? `/api/user-role-permissions/role/${roleId}` : null,
    undefined,
    token ?? '',
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    },
  )

  return {
    permissions: data?.data ?? [],
    isLoading: enabled ? isLoading : false,
    isError: enabled ? error : null,
    mutate,
  }
}
